import type { MapMilestoneDefinition, MapMilestoneStatus } from '@/types/deal-coordination';

/** Standard MAP rows per docs/operations/09-map-template.md */
export const MAP_MILESTONE_DEFINITIONS: readonly MapMilestoneDefinition[] = [
  { milestoneKey: 'M01', sortOrder: 1, label: 'MSA + order form / SOW signed', gateId: 'G1', defaultOwner: 'Customer / Sales' },
  { milestoneKey: 'M02', sortOrder: 2, label: 'Readiness & customer responsibilities exhibit signed', gateId: 'G1', defaultOwner: 'Customer / Sales' },
  { milestoneKey: 'M03', sortOrder: 3, label: 'MAP agreed (this document)', gateId: 'G1', defaultOwner: 'Joint' },
  { milestoneKey: 'M04', sortOrder: 4, label: 'Admin location(s) created; CS owner assigned', gateId: null, defaultOwner: 'TPB' },
  { milestoneKey: 'M05', sortOrder: 5, label: 'POS credentials provided; connectivity test passed', gateId: 'G2', defaultOwner: 'Customer IT + TPB' },
  { milestoneKey: 'M06', sortOrder: 6, label: 'Catalog live in POS (min threshold met)', gateId: 'G3', defaultOwner: 'Customer' },
  { milestoneKey: 'M07', sortOrder: 7, label: 'Network spec confirmed (site survey if needed)', gateId: 'G4', defaultOwner: 'Customer' },
  { milestoneKey: 'M08', sortOrder: 8, label: 'Customer hardware on site (screens, mounts, power)', gateId: 'G5', defaultOwner: 'Customer' },
  { milestoneKey: 'M09', sortOrder: 9, label: 'Power / placement spec signed off', gateId: 'G6', defaultOwner: 'Customer' },
  { milestoneKey: 'M10', sortOrder: 10, label: 'Named retail lead + training roster submitted', gateId: 'G7', defaultOwner: 'Customer' },
  { milestoneKey: 'M11', sortOrder: 11, label: 'Brand / spotlight content approved (or default)', gateId: 'G8', defaultOwner: 'Customer' },
  { milestoneKey: 'M12', sortOrder: 12, label: 'Production / install scheduled', gateId: null, defaultOwner: 'TPB', blocksInstallNote: 'Only after G1–G6 green' },
  { milestoneKey: 'M13', sortOrder: 13, label: 'Install completed', gateId: null, defaultOwner: 'Joint' },
  { milestoneKey: 'M14', sortOrder: 14, label: 'Staff briefing completed', gateId: 'G9', defaultOwner: 'Customer' },
  { milestoneKey: 'M15', sortOrder: 15, label: 'Go-live QA signoff', gateId: 'G10', defaultOwner: 'Joint' },
  { milestoneKey: 'M16', sortOrder: 16, label: '30-day stabilization review', gateId: null, defaultOwner: 'Joint' },
  { milestoneKey: 'M17', sortOrder: 17, label: 'First quarterly business review (QBR)', gateId: null, defaultOwner: 'Joint' },
  { milestoneKey: 'M18', sortOrder: 18, label: 'First monthly pulse / health review in CMS', gateId: null, defaultOwner: 'Joint' },
] as const;

export const MAP_MILESTONE_STATUS_LABELS: Record<MapMilestoneStatus, string> = {
  not_started: 'Not started',
  in_progress: 'In progress',
  complete: 'Done',
  blocked: 'Blocked',
  na: 'N/A',
};

export const WON_HANDOFF_ITEM_DEFINITIONS = [
  {
    itemKey: 'location_linked',
    label: 'Location linked',
    description: 'Deal is linked to an admin location record (convert prospect or attach existing location).',
  },
  {
    itemKey: 'cs_owner_assigned',
    label: 'CS owner assigned',
    description: 'TPB CS owner is set on the deal and copied to the location on convert.',
  },
  {
    itemKey: 'readiness_gates_initialized',
    label: 'Readiness gates open',
    description: 'Location Readiness tab shows G1–G10; verify gate owners and due dates after handoff.',
  },
  {
    itemKey: 'map_reviewed',
    label: 'MAP dates aligned with gates',
    description: 'MAP milestone target dates match readiness gates; mismatches logged in comms/notes.',
  },
] as const;
